import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import apiUrl from '../../utils/apiUrl';

const ENDPOINTS = {
  foundations: '/company/getFoundations',
  campaigns: '/company/getCampaigns',
};

const useGetData = (resourceType, options = {}) => {
  const { method = 'POST', body = {} } = options;
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const companyFromURL = params.get('company');

  let finalBody = { ...body };

  if (!finalBody.company && companyFromURL) {
    finalBody.company = companyFromURL;
  }

  if (typeof finalBody.company === 'object' && finalBody.company !== null) {
    if (finalBody.company.company) {
      finalBody.company = finalBody.company.company;
    }
  }

  const endpointPath = ENDPOINTS[resourceType];
  if (!endpointPath) {
    console.error(`El resourceType "${resourceType}" no es válido.`);
  }
  const endpoint = `${apiUrl.apiUrl}${endpointPath}`;

  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      try {
        const response = await fetch(endpoint, {
          method,
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(finalBody),
        });
        const result = await response.json();
        setData(result);
      } catch (err) {
        console.error('Error al obtener los datos:', err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [endpoint, method, JSON.stringify(finalBody)]);

  return { data, loading, error };
};

export default useGetData;
